import SlSkeleton from './SlSkeleton';

export default SlSkeleton;
